import React, { useState } from 'react';
import { Form, Button, Checkbox, Container, Row, Col } from 'react-bootstrap';
import { FaLaptopCode, FaTools, FaUsersCog } from 'react-icons/fa';
import './Orcamento.css'
import { Helmet } from 'react-helmet';
const OrçamentoForm = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    manutencaoPredial: [],
    tecnologiaInformacao: [],
    consultoria: []
  });

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    if (type === 'checkbox') {
      setFormData(prevState => {
        const newData = { ...prevState };
        if (checked) {
          newData[name] = [...newData[name], value];
        } else {
          newData[name] = newData[name].filter(item => item !== value);
        }
        return newData;
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data submitted:', formData);
  };

  return (
    <div>
<Helmet>
  <html lang="pt-BR" />
  <title>Solicite um Orçamento | Atendimento Personalizado</title>
  <meta name="description" content="Peça seu orçamento agora e receba uma proposta sob medida para sua empresa em manutenção, TI ou consultoria." />
  <meta name="keywords" content="orçamento empresarial, proposta, manutenção, TI, consultoria" />
  <meta property="og:title" content="Solicite um Orçamento | Atendimento Personalizado" />
  <meta property="og:description" content="Fale conosco e descubra como podemos atender sua empresa com soluções eficazes." />
  <meta property="og:image" content="https://nwayami.com/img/orcamento.jpg" />
  <meta property="og:url" content="https://nwayami.com/orcamento" />
  <meta name="robots" content="index, follow" />
</Helmet>
<section className='section'>
<Container className="orcamento-container">
  <h1 className="text-center titulo-principal">Solicitar Orçamento</h1>

  <Form onSubmit={handleSubmit}>
    <Row>
      {/* Coluna Esquerda: Dados Pessoais */}
      <Col md={6}>
        <h4 className="subtitulo">Dado pessoal/Empresarial</h4>

        <Form.Group controlId="nome" className="mb-3">
          <Form.Label>Nome</Form.Label>
          <Form.Control
            type="text"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            placeholder="nome do cliente particular ou empresa"
            required
          />
        </Form.Group>

        <Form.Group controlId="email" className="mb-3">
          <Form.Label>E-mail</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="telefone" className="mb-3">
          <Form.Label>Telefone</Form.Label>
          <Form.Control
            type="tel"
            name="telefone"
            value={formData.telefone}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="empresa" className="mb-3">
          <Form.Label>Mais informações</Form.Label>
          <Form.Control
            as="textarea"
            name="empresa"
            value={formData.empresa}
            onChange={handleChange}
            placeholder="informações sobre o serviço desejado"
            rows={4}
          />
        </Form.Group>

        <Button type="submit"style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '145px', padding: '10px' }}>
          Enviar Solicitação
        </Button>
      </Col>

      {/* Coluna Direita: Serviços de Interesse */}
      <Col md={6}>
        <h4 className="subtitulo">Serviços de Interesse</h4>

        <div className="categoria">
          <h5><FaTools className="icon" /> Manutenção Predial</h5>
          {[
            "Gestão e Manutenção De ETA",
            "Implementação de sistemas de canalização",
            "Manutenção e instalação elétrica de média e alta tensão",
            "Montagem de cancela",
            "Reparação de cancela",
            "Serviços de Jardinagem"
          ].map((item, idx) => (
            <Form.Check
              key={idx}
              type="checkbox"
              label={item}
              name="manutencaoPredial"
              value={item}
              onChange={handleChange}
            />
          ))}
        </div>

        <div className="categoria">
          <h5><FaLaptopCode className="icon" /> Tecnologia de Informação</h5>
          {[
            "Segurança electrónica",
            "Sistema de video vigilância CCTV",
            "Sistema de monitoramento de velocidade (RADAR)",
            "Instalação e manutenção de rede informática e telecomunicação",
            "Instalação de controle de acesso RFID e fechaduras magnéticas",
            "Serviços de energia Renováveis"
          ].map((item, idx) => (
            <Form.Check
              key={idx}
              type="checkbox"
              label={item}
              name="tecnologiaInformacao"
              value={item}
              onChange={handleChange}
            />
          ))}
        </div>
       
        <div className="categoria">
          <h5><FaUsersCog className="icon" /> Consultoria</h5>
          <Form.Check
              type="checkbox"
              label="Manutenção Predial"
              name="consultoria"
              value="Manutenção Predial"
              onChange={handleChange}
            />
            <Form.Check
              type="checkbox"
              label="Tecnologia de Informação"
              name="consultoria"
              value="Tecnologia de Informação"
              onChange={handleChange}
            />
        </div>
      </Col>
      
    </Row>
  </Form>
</Container>

    </section>

    </div>
   
    
  );
};

export default OrçamentoForm;
